import { ButtonBase } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles({ name: 'Puller' })((theme) => ({
  root: {
    backgroundColor: theme.palette.grey[300],
    borderRadius: 12,
    height: 6,
    width: 38,
  },
}));

interface PullerProps {
  readonly onClick: () => void;
}

export const Puller: React.FC<PullerProps> = ({ onClick }) => {
  const { classes } = useStyles();

  return (
    <ButtonBase
      component="div"
      className={classes.root}
      onClick={onClick}
    />
  );
};
